












import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../system/mixins";

@Component({
})
export default class FilterableTextInput extends Mixins(ModelEditableMixin) {
  editingSource: string;

  @Prop({ default: undefined })
  validExpressions: string;

  @Prop({ default: "text" })
  type: string;

  @Prop({ default: false })
  readonly: boolean;

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: string, oldValue: string): void {
    if (!this.validExpressions || (this.validExpressions === "")) {
      return;
    }
    const replaced = newValue.replace(new RegExp("[^" + this.validExpressions + "]", "g"), "");
    if (newValue !== replaced) {
      this.$nextTick(() => {
        this.editingSource = replaced;
      });
    }
  }

  @Emit()
  click(): void {}

  @Emit()
  focus(): void {}

  @Emit()
  blur(): void {}
}
